import { PageviewEvent } from "./PageviewEvent";
import SessionTimer from "./SessionTimer";
import { SetupUser } from "./SetupUser";
import PageNameTest from "./PageNameTest";
import ReactGA from "react-ga4";
import { getRole } from "../../helpers/ReduxHelpers";
import store from "../../redux/store";
import { getPageNameFromPath, getMainMenuFromPath, getSubmenuFromPath } from "./pathToMenuMapper";

export function GoogleAnalytics() {
  return (
    <>
      <SetupUser />
      <PageviewEvent />
      <SessionTimer />
      {/* <PageNameTest /> */}
    </>
  );
}

// Helper function to get user context for events
function getUserContext() {
  const userInfo = store.getState().user.userInfo;
  if (!userInfo?.id) return {};
  
  const roles = getRole();
  return {
    user_name: userInfo?.merchant?.name || 'Unknown',
    user_role: roles.join(', ') || 'Unknown',
    primary_role: roles[0] || 'Unknown',
    merchant_id: userInfo?.merchant?.id || 'Unknown'
  };
}

// Helper function to get current page context
function getPageContext() {
  const pathname = window.location.pathname;
  return {
    page_name: getPageNameFromPath(pathname),
    main_menu: getMainMenuFromPath(pathname),
    submenu_name: getSubmenuFromPath(pathname),
    page_path: pathname
  };
}

// Helper function to track user actions with role context
export function trackUserAction(action, category = "User Action", label = null, value = null) {
  try {
    const userContext = getUserContext();
    const pageContext = getPageContext();
    
    ReactGA.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
      ...userContext,
      ...pageContext
    });
    
    console.log(`Tracked user action: ${action} using gtag`, { category, label, value, userContext, pageContext });
  } catch (error) {
    console.error('Error tracking user action:', error);
  }
}

// Helper function to track page-specific actions with role context
export function trackRoleBasedPageAction(pageName, action, additionalData = {}) {
  try {
    const userContext = getUserContext();
    const pageContext = getPageContext();
    
    // Use provided pageName or fall back to auto-detected page name
    const finalPageName = pageName || pageContext.page_name;
    
    ReactGA.gtag('event', `${finalPageName}_${action}`, {
      event_category: 'Page Action',
      event_label: finalPageName,
      page_name: finalPageName,
      ...userContext,
      ...pageContext,
      ...additionalData
    });
    
    console.log(`Tracked page action: ${finalPageName}_${action} using gtag`, { 
      finalPageName, 
      userContext, 
      pageContext, 
      additionalData 
    });
  } catch (error) {
    console.error('Error tracking page action:', error);
  }
}

// Export utility functions for use in other parts of the application
export { getPageNameFromPath, getMainMenuFromPath, getSubmenuFromPath } from './pathToMenuMapper';
